import React, { Children, cloneElement, Component, Fragment } from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import { withStyles } from 'utils/makeStylesAdapter';
import { Placeholder, PlaceholderSimple, PlaceholderSmall } from './Placeholder';

const styles = {
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
  },
  container: {
    display: 'inline-flex',
    flex: '1 1 auto',
  },
  middle: {
    marginRight: '-10px',
  },
};

const renderPlaceholders = props => {
  const { classes, placeholderCounter, variant = 'default', childrenWithProps } = props;

  if (placeholderCounter) {
    const placeholders = [];
    let index = 0;

    while (index < placeholderCounter) {
      switch (variant) {
        case 'small':
          placeholders.push(
            <PlaceholderSmall
              key={index}
              first={index === 0}
              quantity={childrenWithProps.length}
            />,
          );
          break;
        case 'simple':
          placeholders.push(
            <PlaceholderSimple
              key={index}
              first={index === 0}
              quantity={childrenWithProps.length}
            />,
          );
          break;
        default:
          placeholders.push(
            <Grid key={index} className={classes.middle}>
              <Placeholder />
            </Grid>,
          );
          break;
      }

      index++;
    }

    return placeholders;
  }
};

class Timeline extends Component {
  componentDidMount() {
    const scrollbar = this.scrollbar;
    scrollbar.scrollLeft = scrollbar.scrollWidth;
  }

  componentDidUpdate() {
    const scrollbar = this.scrollbar;
    const start = this.scrollbar.scrollLeft;
    const end = scrollbar.scrollWidth;
    const duration = 1000;
    const startTime = performance.now();

    const smoothScroll = currentTime => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const scrollLeft = start + (end - start) * progress;

      if (this.scrollbar) {
        this.scrollbar.scrollLeft = scrollLeft;
      }

      if (progress < 1) {
        window.requestAnimationFrame(smoothScroll);
      }
    };

    window.requestAnimationFrame(smoothScroll);
  }

  render() {
    const {
      children,
      classes,
      variant = 'default',
      height = variant === 'small' ? 95 : variant === 'simple' ? 135 : 265,
      placeholderCounter = 0,
      placeholder,
      PerfectScrollbarProps,
    } = this.props;
    const childrenWithProps = children
      ? Children.map(children, (child, index) =>
          cloneElement(child, {
            variant,
            placeholder,
            first: index === 0,
          }),
        )
      : [];
    const placeholders = renderPlaceholders({
      classes,
      placeholderCounter,
      variant,
      childrenWithProps,
    });

    return (
      <Grid className={classes.wrapper} style={{ height }}>
        <PerfectScrollbar
          containerRef={element => {
            this.scrollbar = element
            if (element) {
              console.log(element)
              element.scrollLeft = element.scrollWidth;
            }
            return element;
          }}
          {...PerfectScrollbarProps}
        >
          <CssBaseline />
          <Grid className={classes.container}>
            <Fragment>
              {childrenWithProps.map((child, index) => {
                return (
                  <Fragment key={index}>
                    <Grid
                      className={classes.middle}
                      style={{
                        opacity: 0,
                        transform: 'translateX(30px)',
                        animation: `fadeIn 0.2s ease-out ${index * 0.4}s forwards`,
                      }}
                    >
                      {child}
                    </Grid>
                  </Fragment>
                );
              })}

              <style>
                {`
                  @keyframes fadeIn {
                    to {
                      opacity: 1;
                      transform: translateX(0);
                    }
                  }
                `}
              </style>
            </Fragment>
            {placeholderCounter > 0 && placeholder && placeholders}
          </Grid>
        </PerfectScrollbar>
      </Grid>
    );
  }
}

export default withStyles(styles)(Timeline);
